import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BadgeWrapper = styled.div`
`;
const ProgressBlock = styled.div`
	width: fit-content;
    display: flex;
    margin: 0 auto;
    background: #ffffff;
    padding: 5px 30px;
    border-radius: 7px 7px 0 0 ;
`;

const ProgressItem = styled.div`
	display: block;
	width: 12px;
	height: 12px;
	border-radius: 12px;
	border: ${ ({ active }) => !active && '1px solid #00000020' };
	background-color: ${ ({ active }) => active && '#7ac479' };
	margin: 0 3px;
`;
const ContentWrapper = styled.div`
	background: #ffffff;
	padding: 10px 30px;
	border-radius: 7px;
    border: 1px solid #00000040;
`;

const Content = styled.div`
	color:  #7ac479;
	margin-bottom: 15px;
	text-align: center;
`;

const Button = styled.div`
	color: #ffffff;
	background-color: #7ac479; 
	padding: 7px 10px;
    border-radius: 8px;
    box-shadow: 0px 0px 4px 2px rgba(255, 255, 255, 0.70);
	font-family: "Museo";
}
`;

const Badge = ({ goTo, inDOM, content, currentStep, total, stepsCounter, closeTour }) => {
	console.log( stepsCounter );
	return (
		<BadgeWrapper>
			<ProgressBlock>
				{ stepsCounter.map( (i, ind) => {
					return <ProgressItem active={ currentStep === i }/>;
				} ) }
			</ProgressBlock>
			<ContentWrapper>
				<Content>{ content }</Content>
				{ currentStep < total - 1 ? <Button onClick={ () => goTo( currentStep + 1 ) }>Понятно, дальше)</Button>
					: <Button onClick={closeTour}>Закрыть</Button> }
			</ContentWrapper>
		</BadgeWrapper>
	);
};

export default Badge;
